import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import MapPage from "./pages/MapPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import HostAuth from "./pages/HostAuth";
import HostDashboard from "./pages/HostDashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import CalendarPage from "./pages/CalendarPage";
import RegionsPage from "./pages/RegionsPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import SetupWizard from "./pages/SetupWizard";
import CookieConsent from "./components/CookieConsent";
import TrackingPixels from "./components/TrackingPixels";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n";
import { ThemeProvider } from "./theme";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

function App() {
  const [setupDone, setSetupDone] = useState(null); // null = loading

  useEffect(() => {
    axios.get(`${API}/setup/status`)
      .then(r => setSetupDone(r.data.setup_complete))
      .catch(() => setSetupDone(true)); // if endpoint fails, skip wizard
  }, []);

  if (setupDone === null) return null; // loading

  return (
    <ThemeProvider>
      <LanguageProvider>
      <div className="app-container">
        <BrowserRouter>
          <Routes>
            {!setupDone && <Route path="*" element={<SetupWizard />} />}
            {setupDone && (
              <>
                <Route path="/" element={<MapPage />} />
                <Route path="/portal-d7glqibsq4" element={<AdminLogin />} />
                <Route path="/portal-d7glqibsq4/dashboard" element={<AdminDashboard />} />
                <Route path="/host" element={<HostAuth />} />
                <Route path="/host/dashboard" element={<HostDashboard />} />
                <Route path="/host/payment-success" element={<PaymentSuccess />} />
                <Route path="/calendar" element={<CalendarPage />} />
                <Route path="/regions" element={<RegionsPage />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/setup" element={<Navigate to="/" replace />} />
              </>
            )}
          </Routes>
          <Toaster position="top-center" richColors />
          {setupDone && <TrackingPixels />}
          {setupDone && <CookieConsent />}
        </BrowserRouter>
      </div>
    </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
